// Per-browser "Recent" Global Search entries - local only, no backend. Scoped per
// company + user (same companyDomain slug the rest of GlobalSearch already keys
// off, plus the logged-in user's own _id) so a shared/public browser doesn't leak
// one person's recent searches to whoever logs in next on the same machine.
//
// Each stored entry is a flattened, minimal shape - never the raw API record -
// just enough to re-render a result row later and navigate on click again.
import { getGlobalSearchKeySuffix } from "./globalSearchStorageKey";

const MAX_RECENT = 5;

const getStorageKey = () => `globalSearch.recent.${getGlobalSearchKeySuffix()}`;

export const getRecentSearches = () => {
  try {
    const raw = localStorage.getItem(getStorageKey());
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

// `entry` is the minimal {id, label, subtitle, icon-category, color, navigate}
// shape built by the caller - `id` is used only for de-duplication (re-selecting
// the same result moves it to the top instead of adding a duplicate row).
export const addRecentSearch = (entry) => {
  if (!entry?.id) return;
  try {
    const existing = getRecentSearches().filter((item) => item.id !== entry.id);
    const next = [entry, ...existing].slice(0, MAX_RECENT);
    localStorage.setItem(getStorageKey(), JSON.stringify(next));
  } catch (e) {
    // Private browsing / storage blocked - fail soft, Recent is a nice-to-have.
  }
};
